import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

const ComparisonValueSchema = z.unknown().array()

/** TODO: unit test */
export class In extends Operator<unknown> {
  constructor() {
    super(LOGIC_OPERATOR.IN, z.unknown())
  }

  evaluate(factValue: unknown, comparisonValue: ComparisonValue): boolean {
    const _comparisonValue = ComparisonValueSchema.parse(comparisonValue)

    return _comparisonValue.indexOf(factValue) > -1
  }
}
